export const woTableColumnGroups = [
    {
        label: 'ACTIVITY STATUS',
        keys: ['activityStatusAndName', 'activityItemId', 'activityTypeId', 'l1ApproverName', 'l2ApproverName', 'lastActivity', 'daysOpen'],
    },
    {
        label: 'WORK ORDER CONTEXT',
        keys: ['workOrderId', 'activityDateFormatted', 'requestedCompletionDateFormatted', 'customActivity', 'repairOrder', 'l2ApprovalAmount', 'price', 'revenue', 'createdBy', 'vendor', 'lot'],
    },
    {
        label: 'ASSET INFO',
        keys: ['descriptor', 'assetId', 'client', 'subClient', 'currentLocation'],
    },
];
